// @core/api/endpoints/form/reorder_form_fields.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReorderFormFieldsRequest,
  ReorderFormFieldsResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Reorder form fields
 * Updates the display order of fields within a form page.
 */
export async function ReorderFormFields(
  form_id: string,
  data: ReorderFormFieldsRequest,
  options?: RequestOptions
): Promise<ReorderFormFieldsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/fields/reorder`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<ReorderFormFieldsResponse>(requestPath, data, requestOptions);
}
